import Vue from "vue";
import Vuex from "vuex";
import BootstrapVue from "bootstrap-vue";
import persist from "vuex-localstorage";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
import "swagger-ui/dist/swagger-ui.css";

Vue.use(Vuex);
Vue.use(BootstrapVue);

// Modules
import auth from "./auth.js";

export default new Vuex.Store({
    plugins: [
        persist({
            namespace: "aws-vuejs-cognito",
            initialState: {},
            expires: 7 * 24 * 60 * 60 * 1e3 // 1 week
        })
    ],
    modules: {
        auth
    },
    state: {
        environment: "dev",
    	dev: {
	    	AWS_COGNITO_USER_POOL_DOMAIN: "auth.test.eventboost.com",
	        AWS_COGNITO_CLIENT_ID: "ra741jrc1h1ot41gvh8pe19iv",
	        AUTH_TEST_API_ENDPOINT: "https://localhost:8080",
	        API_BASE: "https://dev.eventboost.com/api/dev",
	        
	        AWS_COGNITO_CLIENT_ID_CC: "6lc8k5n9s293mv5kcg5q163rut",
	        AWS_COGNITO_CLIENT_SECRET_CC: "30918lvanpcdfp8s8vlgm6bnr4qgnc8n3qakbmr4roii2g0bvbc"
    	},
        prod: {
        	AWS_COGNITO_USER_POOL_DOMAIN: "auth.eventboost.io",
        	AWS_COGNITO_CLIENT_ID: "1ip1tsfsdbpl8h00p37q7nb7rg",
	        AUTH_TEST_API_ENDPOINT: "https://localhost:8080",
	        API_BASE: "https://api.eventboost.io/latest",
	        
	        AWS_COGNITO_CLIENT_ID_CC: "3uq7fsreda7qpjfoil12oo441k",
	        AWS_COGNITO_CLIENT_SECRET_CC: "1sbcfv4cu567s51mplrhuo04e2co7v0fp8j28ujj20dtjvkglq1t"
        }
        	
    },
    getters: {
        AWS_COGNITO_USER_POOL_DOMAIN: state => state[state.environment].AWS_COGNITO_USER_POOL_DOMAIN,
        AWS_COGNITO_CLIENT_ID: state => state[state.environment].AWS_COGNITO_CLIENT_ID,
        AUTH_TEST_API_ENDPOINT: state => state[state.environment].AUTH_TEST_API_ENDPOINT,
        apiBase: state => state[state.environment].API_BASE,
        
        AWS_COGNITO_CLIENT_ID_CC: state => state[state.environment].AWS_COGNITO_CLIENT_ID_CC,
        AWS_COGNITO_CLIENT_SECRET_CC: state => state[state.environment].AWS_COGNITO_CLIENT_SECRET_CC,
        
        environment: state => state.environment
    },
    mutations: {
        setEnvironment: (state, environment) => {
            state.environment = environment;
        }
    },
    actions: {
    	changeEnvironment: function(context, env) {
        	context.commit("setEnvironment", env);
        }
    }
});
